export default httpClient => ({
  save: async ({ dados, token }) => {
    const headers = { "Authorization": "Bearer " + token, "Accept": "application/json" }
    const response = await httpClient.post('/profissionais', dados, { headers });
    return {
      data: response.data,
    }
  },
  savePlano: async ({ planos, profissional_id, token }) => {
    const headers = { "Authorization": "Bearer " + token, "Accept": "application/json" }
    const response = await httpClient.post('/planos-profissionais', { planos, profissional_id }, { headers })
    return {
      data: response.data,
    }
  },
  update: async ({ dados, token }) => {
    const headers = { "Authorization": "Bearer " + token, "Accept": "application/json" }
    const response = await httpClient.post('/profissionais/' + dados.get('id'), dados, { headers });
    return {
      data: response.data
    }
  },
  getById: async ({ id, token }) => {
    const headers = { "Authorization": "Bearer " + token, "Accept": "application/json" }
    const response = await httpClient.get('/profissionais/' + id, { headers });
    return {
      data: response.data
    }
  },
  getAll: async ({ token }) => {
    const headers = { "Authorization": "Bearer " + token, "Accept": "application/json" }
    const response = await httpClient.get('/profissionais', { headers });
    return { data: response.data }
  },
  getProfissionaisDestaques: async ({ token }) => {
    const headers = { "Authorization": "Bearer " + token, "Accept": "application/json" }
    const response = await httpClient.get('/profissionais-destaque', { headers });
    return { data: response.data }
  },

  delete: async ({ id, token }) => {
    const headers = { "Authorization": "Bearer " + token, "Accept": "application/json" }
    const response = await httpClient.delete('/profissionais/' + id, { headers });
    return {
      data: response
    }
  },

  //----------IMAGENS profissionais

  getAllImg: async ({ token }) => {
    const headers = { "Authorization": "Bearer " + token, "Accept": "application/json" }
    const response = await httpClient.get('/imagens-profissionais', { headers });
    return { data: response.data }
  },
  deleteImg: async ({ id, token }) => {
    const headers = { "Authorization": "Bearer " + token, "Accept": "application/json" }
    const response = await httpClient.delete('/imagens-profissionais/' + id, { headers });
    return {
      data: response
    }
  },
  saveImg: async (dados, token) => {
    const headers = { "Authorization": "Bearer " + token, "Accept": "application/json", "Content-Type": "multipart/form-data" }
    const response = await httpClient.post('/imagens-profissionais', dados, { headers });
    console.log(dados)
    return {
      data: response.data
    }
  },
  getImgById: async ({ id, token }) => {
    const headers = { "Authorization": "Bearer " + token, "Accept": "application/json" }
    const response = await httpClient.get('/imagens-profissionais/' + id, { headers });
    return {
      data: response.data
    }
  },
  deletarImagem: async ({ id, token }) => {
    const headers = { "Authorization": "Bearer " + token, "Accept": "application/json" }
    const response = await httpClient.delete('/deletar-imagem/' + id, { headers });
    return {
      data: response
    }
  },
  updateImg: async (dados, token) => {
    const headers = { "Authorization": "Bearer " + token, "Accept": "application/json", "Content-Type": "multipart/form-data" }
    const response = await httpClient.post('/imagens-profissionais/' + dados.get('id'), dados, { headers });
    return {
      data: response.data
    }
  },
});